export function getCookieValue(cookieName: string): string {
  if (typeof document === "undefined") {
    throw new Error("getCookieValue must be called on the client side");
  }

  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${encodeURIComponent(cookieName)}=`));

  return match ? decodeURIComponent(match.split("=")[1]) : "anonymous";
}
